import React from "react";
import "antd/dist/antd.less";
import { Provider } from "react-redux";
import { createStore, applyMiddleware } from "redux";
import rootReducer from "./reducers";
// import logger from "redux-logger";
import thunk from "redux-thunk";
import Root from "./root/root";
import { sessionService } from "redux-react-session";
import "./App.css";
import { Api } from "./services";
import { saveToLocalStorage, loadFromLocalStorage } from "./store";
// import ReactQuill, {Quill} from "react-quill";
import katex from "katex";
import "katex/dist/katex.min.css";
import "react-multi-carousel/lib/styles.css";
import logger from "redux-logger";
import firebaseApp from "pages/schedule/firebase";
import { getMessaging, getToken,onMessage } from "firebase/messaging"
import { setDownloadMeta } from "actions/broadcast";

window.katex = katex;

const persistedState = loadFromLocalStorage();
export const store = createStore(
  rootReducer,
  persistedState,
  applyMiddleware(thunk, logger)
  // applyMiddleware(thunk)
);
// add , logger
store.subscribe(() => saveToLocalStorage(store.getState()));
sessionService.initSessionService(store).then((data) => {
  const { authenticated, user } = store.getState()["session"];
  if (authenticated) {
    console.log("Authenticated", authenticated);
    const token = user.accessToken;
    Api.header(token);
  }
});
window.store = store;

// Session invalidation (e.g. the same account logging in on another browser)
// is otherwise only caught reactively, the next time some page happens to
// call the API. A page the user is just sitting on and clicking around in
// (no active fetches) would never notice until they eventually navigate
// somewhere that does. This pings a cheap, already-used-elsewhere endpoint on
// any click while authenticated so a stale session gets caught promptly
// wherever the user is.
//
// suppressLogout(): a student's role/privilege signal on this endpoint changes
// on ANY batch/course assignment change (add or remove), even when they still
// have another one assigned - that's not proof the session is invalid, just
// that this one background probe is stale. Forcing a hard redirect off of a
// passive click-driven ping (rather than an action the student actually took)
// would yank them away even when a real, explicit check elsewhere (e.g. the
// student-test "MY ACCOUNT" flow) already confirmed their access is fine. A
// genuinely invalidated session (logged in elsewhere, token revoked, etc.)
// still gets caught the normal way the next time the student's own actions
// call a non-suppressed endpoint - this probe no longer needs to be the one
// to force that.
let _lastSessionPing = 0;
const SESSION_PING_INTERVAL_MS = 5000;
const pingSessionOnClick = () => {
  const { authenticated, user } = store.getState()["session"];
  if (!authenticated || !user?.id) {
    return;
  }
  const now = Date.now();
  if (now - _lastSessionPing < SESSION_PING_INTERVAL_MS) {
    return;
  }
  _lastSessionPing = now;
  Api.get("/user/get-user-menu-settings").params({ userId: user.id }).suppressSnackbar().suppressLogout().send(() => {});
};

class App extends React.Component {
  onUnload(){
    store.dispatch(setDownloadMeta('clear'));
  }
  componentDidMount() {
    store.dispatch(setDownloadMeta('clear'));
    window.addEventListener("beforeunload", this.onUnload);
    document.addEventListener("click", pingSessionOnClick);
    document.title = "aulas";
    if (window.__revealAppTimeout) clearTimeout(window.__revealAppTimeout);
    window.__revealApp && window.__revealApp();
    // const script = document.createElement("script");
    // script.src = "https://cdn.quilljs.com/1.3.6/quill.js";
    // script.async = true;
    // document.body.appendChild(script);
    // const messaging = firebaseApp.messaging()
    // messaging
    // .requestPermission()
    // .then(()=>{
    //   return messaging.getToken()
    // })
    // .then((token)=>{
    //   console.log("token..",token)
    // })
    // .catch(error=>{
    //   console.log("error",error)
    // })


    const messaging = getMessaging();
    // messaging
    // .requestPermission()
    // .then(() => {
    //   console.log("Permission Granted")
    // })
    // .catch((err) => {
    //   console.log("Error",err)
    // });
    getToken(messaging, { vapidKey: 'BF4b1LNVWNOCQMS0Zw7_LsB_VecHFAKNi_2bFABzH00yV7jRrd2ZGnigPBfJ_MFsHkc-lDdemOfNR0v30f8Wfto' })
    .then((currentToken) => {  if (currentToken)
       { 
        } 
        else { 
          console.log('No registration token available. Request permission to generate one.');  }})
          .catch((err) => {  console.log('An error occurred while retrieving token. ', err);  });
    
    onMessage(messaging, (payload) => {  
      console.log('Message received. ', payload); 
    });

  }
  componentWillUnmount(){
    window.removeEventListener("beforeunload", this.onUnload);
    document.removeEventListener("click", pingSessionOnClick);
  }
  render() {
    return (
      <Provider store={store}>
        <Root />
      </Provider>
    );
  }
}

export default App;
